import { ToastContainer } from "react-toastify";
import "./App.scss";
import RouterPath from "./Router/Router";

import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import "react-toastify/dist/ReactToastify.css";
import { store } from "./store/store";

function App() {
  return (
    <>
      <HelmetProvider>
        <Provider store={store}>
          <RouterPath />
          <ToastContainer />
        </Provider>
      </HelmetProvider>
    </>
  );
}

export default App;
